module.exports = __webpack_public_path__ + "static/media/LoadingBlob.91fba34f.svg";